<div style="display: inline; align-items: flex-start;" data-cy="financial-summary-filter-container">
  <mat-grid-list cols="3" rowHeight="26px" class="grid-list-container" data-cy="financial-summary-filter-grid">
    <mat-grid-tile [colspan]="3" [rowspan]="1" class="mat-grid-tile-container" data-cy="financial-summary-filter-report-for-header">
      <p style="font-weight: bolder; padding-top: 10px; margin-right: auto" data-cy="financial-summary-filter-report-for-title">Report For</p>
    </mat-grid-tile>
    <mat-radio-group aria-label="Report For" data-cy="financial-summary-filter-report-for-group">
      <mat-grid-tile [colspan]="1" [rowspan]="2" class="mat-grid-tile-container" data-cy="financial-summary-filter-provider-radio-container">
        <mat-radio-button value=true (change)="radioChange($event)" style="margin-left: 5px" data-cy="financial-summary-filter-provider-radio">Provider</mat-radio-button>
      </mat-grid-tile>
      <mat-grid-tile [colspan]="2" [rowspan]="2" class="mat-grid-tile-container" data-cy="financial-summary-filter-provider-select-container">
        @if (isReportForProvide) {
          <div style="width: 100%;" data-cy="financial-summary-filter-provider-select-wrapper">
            <mat-form-field floatLabel="auto" style="width: 100%; background-color: white; border-radius: 8px;" data-cy="financial-summary-filter-provider-form-field">
              <!--<mat-label>Select a Provider</mat-label>!-->
              <mat-select [formControl]="doctor" required data-cy="financial-summary-filter-provider-select">
                @for (doctor of staticDataService.currentLocationDoctors; track doctor) {
                  <mat-option (onSelectionChange)="onDoctorSelect(doctor,$event)" [value]="doctor" [attr.data-cy]="'financial-summary-filter-provider-option-' + doctor.dataContact.LastName.toLowerCase()">
                    {{doctor.dataContact.FirstName}} {{doctor.dataContact.LastName}}
                  </mat-option>
                }
              </mat-select>
              <!--<mat-error *ngIf="doctor.hasError('required')">Please choose Provider</mat-error>!-->
            </mat-form-field>
          </div>
        }
      </mat-grid-tile>
      <mat-grid-tile [colspan]="1" [rowspan]="2" class="mat-grid-tile-container" data-cy="financial-summary-filter-practice-radio-container">
        <mat-radio-button value=false checked="true" (change)="radioChange($event)" style="margin-left: 5px" data-cy="financial-summary-filter-practice-radio">Practice</mat-radio-button>
      </mat-grid-tile>
      <mat-grid-tile [colspan]="2" [rowspan]="2" class="mat-grid-tile-container" data-cy="financial-summary-filter-practice-dropdown-container">
        @if (!isReportForProvide) {
          <div style="width: 100%;" data-cy="financial-summary-filter-practice-dropdown-wrapper">
            <app-tdo-dropdown [dataSource]="clientList"
              dataSourceDisplayKey="Name"
              [isObjectValue]="true"
              [value]="selectedClient"
              (selectionChange)="onChangeClient($event)"
              data-cy="financial-summary-filter-practice-dropdown">
            </app-tdo-dropdown> <!--placeholder="Practice (Licensee)"!-->
          </div>
        }
      </mat-grid-tile>
    </mat-radio-group>
    <mat-grid-tile [colspan]="3" [rowspan]="1" class="mat-grid-tile-container" data-cy="financial-summary-filter-date-range-header">
      <p style="font-weight: bolder; padding-top: 10px; margin-right: auto" data-cy="financial-summary-filter-date-range-title">Date Range</p>
    </mat-grid-tile>
    <mat-grid-tile [colspan]="1" [rowspan]="3" class="mat-grid-tile-container" data-cy="financial-summary-filter-date-range-spacer">
    </mat-grid-tile>
    <mat-grid-tile [colspan]="2" [rowspan]="3" class="mat-grid-tile-container" data-cy="financial-summary-filter-date-range-dropdown-container">
      <app-tdo-dropdown placeholder="Select Date Range"
        style="width: 100%"
        [dataSource]="filterDateRangesEnums"
        dataSourceDisplayKey="ItemDisplayValue"
        [isObjectValue]="true"
        [value]="selectedDateRanges"
        (selectionChange)="onChangeDateRanges($event)"
        data-cy="financial-summary-filter-date-range-dropdown">
      </app-tdo-dropdown>
    </mat-grid-tile>
    <mat-grid-tile [colspan]="1" [rowspan]="2" class="mat-grid-tile-container" data-cy="financial-summary-filter-date-picker-spacer">
    </mat-grid-tile>
    <mat-grid-tile [colspan]="2" [rowspan]="2" class="mat-grid-tile-container" data-cy="financial-summary-filter-date-picker-container">
      <mat-form-field appearance="fill" class="example-form-field" style="width: 100%; height: 55px" data-cy="financial-summary-filter-date-picker-form-field">
        <mat-label data-cy="financial-summary-filter-date-picker-label">Enter a date range</mat-label>
        <mat-date-range-input [rangePicker]="rangePicker" data-cy="financial-summary-filter-date-picker-input">
          <input matStartDate placeholder="Start date" [(ngModel)]="startDate" disabled="false" data-cy="financial-summary-filter-date-picker-start">
          <input matEndDate placeholder="End date" [(ngModel)]="endDate" disabled="false" data-cy="financial-summary-filter-date-picker-end">
        </mat-date-range-input>
        <mat-hint data-cy="financial-summary-filter-date-picker-hint">MM/DD/YYYY – MM/DD/YYYY</mat-hint>
        <mat-datepicker-toggle matSuffix [for]="rangePicker" data-cy="financial-summary-filter-date-picker-toggle"></mat-datepicker-toggle>
        <mat-date-range-picker #rangePicker data-cy="financial-summary-filter-date-range-picker">
          <mat-date-range-picker-actions data-cy="financial-summary-filter-date-picker-actions">
            <button mat-button matDateRangePickerCancel data-cy="financial-summary-filter-date-picker-cancel">Cancel</button>
            <button mat-raised-button color="primary" matDateRangePickerApply (click)="UserDefined()" data-cy="financial-summary-filter-date-picker-apply">Apply</button>
          </mat-date-range-picker-actions>
        </mat-date-range-picker>
      </mat-form-field>
    </mat-grid-tile>
  </mat-grid-list>
</div>
